import { Breadcrumbs } from 'AbstractElements';
import CoursesContain from 'Component/Learning/Courses';

const CourseList = () => {
	return (
		<>
			<Breadcrumbs mainTitle="Course" parent="Membership" title="Daftar Course" />
			<CoursesContain />
		</>
	);
};
export default CourseList;